import { mapState, mapGetters, mapActions } from 'vuex';
import _ from 'lodash';

import Swal from 'sweetalert2';
import VDistpicker from 'v-distpicker';

import TrackerButton from '@/components/TrackerButton.vue';
import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import Spinner from '@/components/Spinner.vue';

import { SurveyMixin } from '@/mixins/Survey/Survey';

export default {
  name: 'EsgRegistration',

  mixins: [SurveyMixin],

  components: {
    SharedHeader,
    SharedFooter,
    Spinner,
    TrackerButton,
    'v-distpicker': VDistpicker,
  },

  data: () => {
    return {
      active: 0,

      //
      name: '',
      initName: '',

      identityType: 1,
      initIdentityType: 1,

      identityNo: '',
      initIdentityNo: '',
      isShowInvalidMsgIdentityNo: false,

      tel: '',
      initTel: '',
      isShowInvalidMsgTel: false,

      sms: '',
      isShowInvalidMsgSms: false,
      smsCountDown: 0,

      qualification: '',
      initQualification: '',
      columnsQualification: ['大学专科', '大学本科', '硕士研究生', '博士研究生'],

      profession: '注册ESG分析师',

      grade: '',
      initGrade: '',
      gradeOptions: [
        { text: '初级', value: '7671' },
        { text: '中级', value: '7672' },
        { text: '高级', value: '7673' },
        { text: '中级+高级', value: '7680' },
        { text: '初级+中级+高级', value: '7696' },
      ],

      date: '',
      initDate: '',
      columnsDate: [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
      ],

      fileIdentityImg: null,
      fileIdentityImgSrc: '',

      //
      gender: '',
      initGender: '',

      company: '',
      initCompany: '',

      industry: '',
      initIndustry: '',

      province: '',
      city: '',
      area: '',
      areaCode: '',
      initAreaCode: '',

      addressDetail: '',
      initAddressDetail: '',
    };
  },

  computed: {
    ...mapState({
      ms_isIosSafari: (state) => state.browserInfo.isIosSafari,
    }),

    ...mapGetters({
      immLoading: 'immLoading',
    }),

    c_vendor_oid() {
      return this.$route.query.vendor_oid ? this.$route.query.vendor_oid : undefined;
    },

    ///
    c_surveyId() {
      return 1;
    },

    c_isIdentityTypeMainland() {
      return 1 === this.identityType;
    },

    c_isIdentityNoNotReady() {
      return this.c_isIdentityTypeMainland
        ? !this.mainlandIdentityNoValidator(this.identityNo)
        : '' === this.identityNo;
    },

    c_isShowInvalidMsgIdentityNo() {
      return (
        this.isShowInvalidMsgIdentityNo &&
        this.c_isIdentityTypeMainland &&
        !this.mainlandIdentityNoValidator(this.identityNo)
      );
    },

    c_tel() {
      return `+86${this.tel}`;
    },

    c_isTelNotReady() {
      return !this.telValidator(this.tel);
    },

    c_isShowInvalidMsgTel() {
      return this.isShowInvalidMsgTel && this.c_isTelNotReady;
    },

    c_isMobileDifferentFromLastTime() {
      if (this.ms_res_checkSurveyHasposted.hasPosted) {
        return this.tel !== this.initTel;
      } else {
        return false;
      }
    },

    c_isNeedSms() {
      if (this.ms_res_checkSurveyHasposted.hasPosted) {
        return this.c_isMobileDifferentFromLastTime;
      } else {
        return true;
      }
    },

    c_isSmsDisabled() {
      return this.c_isTelNotReady || 0 !== this.smsCountDown;
    },

    c_isSmsNotReady() {
      return !this.smsValidator(this.sms);
    },

    c_isShowInvalidMsgSms() {
      return this.isShowInvalidMsgSms && !/^\d{6}$/.test(this.sms);
    },

    c_goodsId() {
      const selectedOption = _.find(this.gradeOptions, (option) => this.grade === option.text);
      return selectedOption ? selectedOption.value : '';
    },

    c_isFileIdentityImgEmpty() {
      return !this.fileIdentityImg;
    },

    c_isFileIdentityImgDifferentFromLastTime() {
      if (this.ms_res_checkSurveyHasposted.hasPosted) {
        return !this.c_isFileIdentityImgEmpty;
      } else {
        return false;
      }
    },

    c_isFileIdentityImgTooLarge() {
      return !this.c_isFileIdentityImgEmpty && this.fileIdentityImg.size > 5 * 1024 * 1024;
    },

    c_isFileIdentityImgNotReady() {
      if (this.ms_res_checkSurveyHasposted.hasPosted) {
        return this.c_isFileIdentityImgTooLarge;
      } else {
        return this.c_isFileIdentityImgEmpty || this.c_isFileIdentityImgTooLarge;
      }
    },

    c_area() {
      return `${this.province} ${this.city} ${this.area}`;
    },

    c_isFormDifferentFromLastTime() {
      if (this.ms_res_checkSurveyHasposted.hasPosted) {
        return (
          this.name !== this.initName ||
          this.identityType !== this.initIdentityType ||
          this.identityNo !== this.initIdentityNo ||
          this.tel !== this.initTel ||
          this.qualification !== this.initQualification ||
          this.grade !== this.initGrade ||
          this.date !== this.initDate ||
          this.c_isFileIdentityImgDifferentFromLastTime ||
          this.gender !== this.initGender ||
          this.company !== this.initCompany ||
          this.industry !== this.initIndustry ||
          this.areaCode !== this.initAreaCode ||
          this.addressDetail !== this.initAddressDetail
        );
      } else {
        return false;
      }
    },

    c_isNeedSubmit() {
      if (this.ms_res_checkSurveyHasposted.hasPosted) {
        return this.c_isFormDifferentFromLastTime;
      } else {
        return true;
      }
    },

    ///
    c_isSubmitDisabled() {
      if (this.c_isNeedSubmit) {
        if ('' === this.name) {
          return true;
        } else if (this.c_isIdentityNoNotReady) {
          return true;
        } else if (this.c_isTelNotReady) {
          return true;
        } else if (this.c_isNeedSms && this.c_isSmsNotReady) {
          return true;
        } else if ('' === this.qualification) {
          return true;
        } else if ('' === this.profession) {
          return true;
        } else if ('' === this.grade) {
          return true;
        } else if ('' === this.date) {
          return true;
        } else if (this.c_isFileIdentityImgNotReady) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    c_surveyFormId() {
      if (this.ms_res_makeSurveyNew.data && this.ms_res_makeSurveyNew.data.surveyFormId) {
        return this.ms_res_makeSurveyNew.data.surveyFormId;
      } else if (this.ms_res_checkSurveyHasposted.hasPosted) {
        return this.ms_res_checkSurveyHasposted.surveyFormId;
      } else {
        return '';
      }
    },
  },

  methods: {
    ...mapActions({
      ma_mallSmsRegisterV2: 'mallSmsRegisterV2',
    }),

    handleInputIdentityNo() {
      this.isShowInvalidMsgIdentityNo = false;
    },

    handleChangeIdentityNo() {
      this.isShowInvalidMsgIdentityNo = true;
    },

    mainlandIdentityNoValidator(val) {
      return /^\d{17}(\d|X)$/i.test(val);
    },

    handleInputTel() {
      this.isShowInvalidMsgTel = false;
    },

    handleChangeTel() {
      this.isShowInvalidMsgTel = true;
    },

    telValidator(val) {
      return /^1\d{10}$/.test(val);
    },

    handleInputSms() {
      this.isShowInvalidMsgSms = false;
    },

    handleChangeSms() {
      this.isShowInvalidMsgSms = true;
    },

    smsValidator(val) {
      return /^\d{6}$/.test(val);
    },

    mallSmsRegisterV2() {
      this.ma_mallSmsRegisterV2({ mobile: this.c_tel });
      this.$refs.fieldSms.focus();
      this.smsCountDown = 59;
      const itvlSmsCountDown = setInterval(() => {
        this.smsCountDown -= 1;
        if (0 === this.smsCountDown) {
          clearInterval(itvlSmsCountDown);
        }
      }, 1000);
    },

    handleClickIdentityImgBtn() {
      this.$refs.fileIdentityImg.click();
    },

    onOversizeIdentityImg() {
      Swal.fire({
        width: '400px',
        icon: 'warning',
        title: '图片不能超过5MB',
        confirmButtonColor: '#3085d6',
        confirmButtonText: '确定',
      });
    },

    handleChangeFileIdentityImg() {
      this.fileIdentityImg = this.$refs.fileIdentityImg.files[0];
      if (!this.c_isFileIdentityImgEmpty) {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          this.fileIdentityImgSrc = e.target.result;
        };
        fileReader.readAsDataURL(this.fileIdentityImg);
        if (this.c_isFileIdentityImgTooLarge) {
          this.onOversizeIdentityImg();
        }
      } else {
        this.fileIdentityImgSrc = '';
      }
    },

    handleChangeProvince(province) {
      this.province = province.value;
      this.areaCode = province.code ? province.code : '';
    },

    handleChangeCity(city) {
      this.city = city.value;
      this.areaCode = city.code ? city.code : this.areaCode;
    },

    handleChangeArea(area) {
      this.area = area.value;
      this.areaCode = area.code ? area.code : this.areaCode;
    },

    ///
    async doMakeSurveyNew() {
      const formData = new FormData();

      formData.append('surveyId', this.c_surveyId);
      formData.append('name', this.name);
      formData.append('idNumberType', this.identityType);
      formData.append('idNumber', this.identityNo);
      formData.append('mobileNo', this.c_tel);
      formData.append('mobileNoCode', this.sms);
      formData.append('education', this.qualification);
      formData.append('profession', this.profession);
      formData.append('examLevel', this.grade);
      formData.append('examDate', this.date);
      formData.append('idImage', this.fileIdentityImg);

      formData.append('gender', this.gender);
      formData.append('institution', this.company);
      formData.append('industry', this.industry);
      formData.append('city', this.c_area);
      formData.append('cityNumber', this.areaCode);
      formData.append('address', this.addressDetail);

      await this.ma_makeEsgSurveyNew(formData);
    },

    ///
    async afterMakeSurveyNew() {
      if (1 === this.ms_res_makeSurveyNew.data.result) {
        await Swal.fire({
          width: '400px',
          icon: 'success',
          title: this.ms_res_makeSurveyNew.message,
          confirmButtonColor: '#3085d6',
          confirmButtonText: '确定',
        });
        this.gotoOrderConfirmPage();
      } else {
        Swal.fire({
          width: '400px',
          icon: 'warning',
          title: this.ms_res_makeSurveyNew.message,
          confirmButtonColor: '#3085d6',
          confirmButtonText: '确定',
        });
      }
    },

    gotoOrderConfirmPage() {
      let path = `/order/${this.c_goodsId}`;
      path = `${path}?surveyFormId=${this.c_surveyFormId}`;
      if (this.c_vendor_oid) {
        path += `&vendor_oid=${this.c_vendor_oid}`;
      }
      this.$router.push(path);
    },

    async onSubmit() {
      if (this.c_isNeedSubmit) {
        await this.makeSurveyNew();
      } else {
        this.gotoOrderConfirmPage();
      }
    },

    async _EsgFormCreated() {
      await this.ma_checkSurveyHasposted({
        surveyId: 1,
      });
      if (this.ms_res_checkSurveyHasposted.hasPosted) {
        const surveyEntityIdNumberName = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'idNumberName' === surveyEntity.surveyItemKey
        );
        this.name = surveyEntityIdNumberName.surveyItemValue;
        this.initName = this.name;

        const surveyEntityIdNumberType = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'idNumberType' === surveyEntity.surveyItemKey
        );
        this.identityType = Number(surveyEntityIdNumberType.surveyItemValue);
        this.initIdentityType = this.identityType;

        const surveyEntityIdNumber = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'idNumber' === surveyEntity.surveyItemKey
        );
        this.identityNo = surveyEntityIdNumber.surveyItemValue;
        this.initIdentityNo = this.identityNo;

        const surveyEntityMobileNo = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'mobileNo' === surveyEntity.surveyItemKey
        );
        this.tel = surveyEntityMobileNo.surveyItemValue.replace('+86', '');
        this.initTel = this.tel;

        const surveyEntityEducation = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'education' === surveyEntity.surveyItemKey
        );
        this.qualification = surveyEntityEducation.surveyItemValue;
        this.initQualification = this.qualification;

        const surveyEntityExamLevel = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'examLevel' === surveyEntity.surveyItemKey
        );
        this.grade = surveyEntityExamLevel.surveyItemValue;
        this.initGrade = this.grade;

        const surveyEntityExamDate = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'examDate' === surveyEntity.surveyItemKey
        );
        this.date = surveyEntityExamDate.surveyItemValue;
        this.initDate = this.date;

        const surveyEntityIdImage = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'idImage' === surveyEntity.surveyItemKey
        );
        this.fileIdentityImgSrc = surveyEntityIdImage.surveyItemValue;

        const surveyEntityGender = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'gender' === surveyEntity.surveyItemKey
        );
        this.gender = surveyEntityGender.surveyItemValue;
        this.initGender = this.gender;

        const surveyEntityInstitutionr = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'institution' === surveyEntity.surveyItemKey
        );
        this.company = surveyEntityInstitutionr.surveyItemValue;
        this.initCompany = this.company;

        const surveyEntityIndustry = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'industry' === surveyEntity.surveyItemKey
        );
        this.industry = surveyEntityIndustry.surveyItemValue;
        this.initIndustry = this.industry;

        const surveyEntityCity = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'city' === surveyEntity.surveyItemKey
        );
        let city = surveyEntityCity.surveyItemValue;
        city = city.split(' ');
        this.province = city[0] ? city[0] : '';
        this.city = city[1] ? city[1] : '';
        this.area = city[2] ? city[2] : '';

        const surveyEntityCityNumber = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'cityNumber' === surveyEntity.surveyItemKey
        );
        this.areaCode = surveyEntityCityNumber.surveyItemValue;
        this.initAreaCode = this.areaCode;

        const surveyEntityAddress = _.find(
          this.ms_res_checkSurveyHasposted.surveyEntity,
          (surveyEntity) => 'address' === surveyEntity.surveyItemKey
        );
        this.addressDetail = surveyEntityAddress.surveyItemValue;
        this.initAddressDetail = this.addressDetail;
        //this.gotoOrderConfirmPage();
      }
    },
  },

  created() {
    this._EsgFormCreated();
  },
};
